import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery, useScript } from 'usehooks-ts'

import { useAddPayment } from '@features/payment/hooks/useAddPayment'
import { useManagePaymentMethods } from '@features/payment/hooks/useManagePaymentMethods'
import { CustomerPaymentMethodItem } from '@features/payment/lib/types'

import Button from '@shared/ui/button'
import Wrapper from '@shared/ui/wrapper'

import CardItem from './card-item/CardItem.tsx'
import Loader from './loader/Loader'
import { PaymentVerifier } from './payment-verifier/PaymentVerifier.tsx'

import styles from './styles.module.scss'


export default function PaymentMethods () {
  const isTablet = useMediaQuery('(max-width: 1279px)')
  const { t } = useTranslation('personal')
  const PAYMENT_SCRIPT: string = import.meta.env.VITE_HALYK_SCRIPT_URL

  const { paymentMethods, loading: isLoadingMethods } =
    useManagePaymentMethods()
  const { addPayment } = useAddPayment()

  const scriptStatus = useScript(PAYMENT_SCRIPT)

  const isLoading = isLoadingMethods || scriptStatus === 'loading'

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <PaymentVerifier />
        <h2 className={styles.root__title}>{t('nav.payment')}</h2>
        {paymentMethods.length ? (
          <div className={styles.root__cards}>
            {paymentMethods
              .filter((el): el is CustomerPaymentMethodItem => el !== null)
              .map((el) => (
                <CardItem key={el.id} data={el} />
              ))}
          </div>
        ) : (
          <div className={styles.root__empty}>
            <ReactSVG wrapper="span" src="/icons/card.svg" />
            <h3>{t('payment.empty')}</h3>
          </div>
        )}
        <Button
          theme={!paymentMethods.length ? 'primary' : 'secondary'}
          onClick={() => addPayment()}
          className={classNames(styles.root__button, {
            [styles['root__button--empty']]: !paymentMethods.length,
          })}
          size={isTablet ? 'medium' : 'large'}
        >
          {t('payment.button')}
        </Button>
      </Wrapper>
    </div>
  )
}
